import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const parnerReportCommissionApi = createAsyncThunk(
  "parnerReportCommission",
  async () => {
    const response = await axiosInstance.get("/getPartnersWithCommissions");
    return response.data;
  }
);

const parnerReportCommissionSlice = createSlice({
  name: "parnerReportCommission",
  initialState: {
    parnerReportCommission: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(parnerReportCommissionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(parnerReportCommissionApi.fulfilled, (state, action) => {
        state.parnerReportCommission = action.payload;
        state.loading = false;
      })
      .addCase(parnerReportCommissionApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default parnerReportCommissionSlice.reducer;
